import styles from './styles.module.scss';

const Divider = () => <div className={styles.divider} />;

export default Divider;
